import React from 'react';
import { Outlet } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext'; // useAuth'ı import etmeye devam edebiliriz, gelecekte gerekebilir
import './Admin.css';

const AdminDashboardLayout = () => {
    // Bu bileşenin kendisi artık navigasyon göstermiyor.
    // Navigasyon tamamen Header'a taşındı.
    // Bu yapı, /management altındaki tüm sayfalar için ortak bir
    // "page-container" ve "admin-layout" sarmalayıcısı sağlar.
    return (
        <div className="page-container admin-layout">
            <main className="admin-content-full">
                <Outlet />
            </main>
        </div>
    );
};

export default AdminDashboardLayout;